export default {
    en: {
        resumePretTitle: 'Mortgage features',
        resumePretTypeTitle: 'Type of mortgage',
        // Pret variable protege
        resumePretTypeVPTextPart1: ' (Maximum rate: ',
        resumePretTypeVPTextPart2: ')',
        // Pret variable réduit
        resumePretInterestTitle: 'Interest rate',
        resumePretInterestOffreVariableOuRevisable: 'Current interest rate',
        resumePretInterestLibelleInfobulleHorsEcranOffreVariableReduitProtegeRevisable:
            'the current interest rate',
        resumePretInterestLibelleInfobulleOffreVariableReduit:
            'Your interest rate increases or decreases with each change in the Desjardins prime rate. The guaranteed rate spread will stay the same throughout the 5-year term.',
        resumePretInterestLibelleInfobulleOffreVariableProtege1:
            'Your interest rate increases or decreases with each change in the Desjardins prime rate, but it can never exceed the maximum rate of ',
        resumePretInterestLibelleInfobulleOffreVariableProtege2: '.',
        resumePretInterestLibelleInfobulleOffreRevisable1:
            'The interest rate is revised every 12\xa0months. A guaranteed spread of ',
        resumePretInterestLibelleInfobulleOffreRevisable2:
            ' is then applied to your new rate.',
        resumePretInterestSubTextPart1: '(Year\xa01)',
        resumePretInterestSubTextPart2: '',
        resumePretInterestSubTextPart3: '',
        resumePretInterestSubTextPart4: ' rebate)',
        resumePretTypeVRTextPart1: '(Prime rate ',
        resumePretTypeVRTextPart2: ' rate spread ',
        resumePretTypeVRTextPart3: ')',
        // Taux interet additionnel assurance
        resumePretInsuranceTitlePaiementSansAssurance:
            'Payment without insurance ',
        resumeChangeButton: 'Edit',
        resumeChangeButtonHorsParcours: 'mortgage features'
    },
    fr: {
        resumePretTitle: 'Caractéristiques du prêt',
        resumePretTypeTitle: 'Type de prêt',
        // Pret variable protege
        resumePretTypeVPTextPart1: ' (Taux maximum : ',
        resumePretTypeVPTextPart2: ')',
        // Pret variable réduit
        resumePretInterestTitle: 'Taux d’intérêt',
        resumePretInterestOffreVariableOuRevisable: 'Taux d’intérêt actuel',
        resumePretInterestLibelleInfobulleHorsEcranOffreVariableReduitProtegeRevisable:
            'le taux d’intérêt actuel',
        resumePretInterestLibelleInfobulleOffreVariableReduit:
            'Le taux d’intérêt augmente ou diminue à chaque variation du taux préférentiel Desjardins. L’écart garanti reste fixe durant 5\xa0ans.',
        resumePretInterestLibelleInfobulleOffreVariableProtege1:
            'Le taux d’intérêt augmente ou diminue à chaque variation du taux préférentiel Desjardins, mais il ne dépassera jamais le taux maximum de ',
        resumePretInterestLibelleInfobulleOffreVariableProtege2: '.',
        resumePretInterestLibelleInfobulleOffreRevisable1:
            'Le taux d’intérêt est révisé aux 12\xa0mois. Un écart garanti de ',
        resumePretInterestLibelleInfobulleOffreRevisable2:
            ' est ensuite appliqué sur le nouveau taux.',
        resumePretInterestSubTextPart1: '(1',
        resumePretInterestSubTextPart2: 're',
        resumePretInterestSubTextPart3: '\xa0année)',
        resumePretInterestSubTextPart4: ')',
        resumePretTypeVRTextPart1: '(Taux préférentiel ',
        resumePretTypeVRTextPart2: ' écart ',
        resumePretTypeVRTextPart3: ')',
        // Taux interet additionnel assurance
        resumePretInsuranceTitlePaiementSansAssurance:
            'Paiement sans assurance',
        resumeChangeButton: 'Modifier',
        resumeChangeButtonHorsParcours: 'les caractéristiques du prêt'
    }
};
